import React, { useEffect, useState } from "react";
import Cart from "../Cart";
import { CAProvinces, stateList } from "../../../util/CommonLists";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import { updateState, states, FirstTermsStates } from "../StateManagement";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GetCountryListAndInternationalSupport } from "../../../util/countryListAndInternationalSupport";
import LogoContainer from "../../common/LogoContainer";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { stateDisclosureAPI } from "../../../components/Dialogs/protectionPlan/GetStateLegalDisclaimer";
import { useButtonText } from "../../commonConstants";

interface IProps {
    setForm: any;
    manageState: any;
    displayData: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
}

const AddressInformation = ({ setForm, manageState, displayData, setRegistrationState, registrationState, registrationLookup }: IProps) => {
    const { supportInternational } = GetCountryListAndInternationalSupport();
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    let countryValue = registrationState.addressInfo && registrationState.addressInfo.country;
    const subscriberDetails = registrationLookup && registrationLookup["subscriberDetails"];
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const userData = displayData.userData;
    const { t: tLang } = useTranslation();
    const LookupType = query.get("Type");
    const checkLookUpType = LookupType === "SSSOFFER" ? true : false;
    const isTypeWalkup = LookupType === "WALKUP";
    const isTypeSSOProvisional = LookupType === "SSO_PROVISIONAL";
    let disclaimerType = "STATE";
    const [selectedState, setSelectedState] = useState("");
    const [nonCredit, setNonCredit] = useState("");
    const [showDisclosure, setShowDisclosure] = useState(false);
    const [creditDisclosureText, setCreditDisclosureText] = useState("");

    let partnerId: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : null
    );

    let RetailerCode: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerCode
            ? state.configurationState.configuration.partnerConfig.retailerCode
            : null
    );
    const NonCreditServiceType = (nonCreditType: any) => {
        nonCreditType ? setNonCredit(nonCreditType) : "";
    }
    let productService: string = "";

    const getproductServiceType = (value: boolean) => {
        setShowDisclosure(value);
        productService = value ? "CREDIT" : nonCredit;
    };

    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    const ShowTermsAndConditionScreenFirst: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.showTermsAndConditionScreenFirst
            : false
    );
    const isPartnerIdIsInfodefender = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 544
                ? true
                : false
            : false
    );

    const isTUUser = () => {
        if (subscriberDetails && subscriberDetails["istuUser"]) {
            return true;
        }
        return false;
    };

    const PSSValue = query.get("GNDNRLL");
    const isPSSUser = () => {
        return PSSValue === "PSS" ? true : false;
    };

    const [isNextOrContinue, isPreviousOrBack] = useButtonText();
    const isAutoEnrollUser = () => {
        if (subscriberDetails && subscriberDetails["isAutoEnrollUser"]) {
            return true;
        }
        return false;
    };

    const getDefaultAddress = () => {
        let address =
            registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0 && registrationState.addressInfo.address1
                ? registrationState.addressInfo.address1
                : userData && userData.address;
        if (!address && ((isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional || (isPSSUser() && isPartnerIdIsInfodefender))) {
            if (subscriberDetails && subscriberDetails["address"]) {
                address = subscriberDetails["address"];
            }
        }

        return address;
    };

    const getDefaultAddress2 = () => {
        let address =
            registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0 && registrationState.addressInfo.address2
                ? registrationState.addressInfo.address2
                : userData && userData.address2;
        if (!address && (isTypeSSOProvisional || (isPSSUser() && isPartnerIdIsInfodefender))) {
            if (subscriberDetails && subscriberDetails["address2"]) {
                address = subscriberDetails["address2"];
            }
        }

        return address;
    };

    const getDefaultCity = () => {
        let city =
            registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0 && registrationState.addressInfo.city
                ? registrationState.addressInfo.city
                : userData && userData.city;
        if (!city && ((isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional || (isPSSUser() && isPartnerIdIsInfodefender))) {
            if (subscriberDetails && subscriberDetails["city"]) {
                city = subscriberDetails["city"];
            }
        }

        return city;
    };

    const getDefaultState = () => {
        let state =
            registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0 && registrationState.addressInfo.state
                ? registrationState.addressInfo.state
                : userData && userData.state;

        if (!state && ((isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional || (isPSSUser() && isPartnerIdIsInfodefender))) {
            if (subscriberDetails && subscriberDetails["state"]) {
                state = subscriberDetails["state"];
                if (countryValue === "CA") {
                    let defaultState = CAProvinces.find((val: any) => {
                        if (val.name.toUpperCase() === subscriberDetails["state"].toUpperCase()) {
                            return val;
                        }
                    });

                    return defaultState && defaultState.value ? defaultState.value : null;
                }
            }
        }

        return state;
    };

    const getDefaultZip = () => {
        let zip =
            registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0 && registrationState.addressInfo.zipcode
                ? registrationState.addressInfo.zipcode
                : userData && userData.zipcode;
        if (!zip && ((isAutoEnrollUser() && isTUUser()) || isTypeSSOProvisional || (isPSSUser() && isPartnerIdIsInfodefender))) {
            if (subscriberDetails && subscriberDetails["zip"]) {
                zip = subscriberDetails["zip"];
            }
        }

        return zip;
    };

    const countryChangeDetected = () => {
        i18nService.setRegionBasedonCountry(countryValue);
        setZipCode(i18nService.get("ZipCode"));
    };

    const { register, handleSubmit, errors, watch } = useForm({
        mode: "onBlur",
    });

    const isBusinessUser = displayData && displayData.isBusinessUser;

    const onStateChange = async (event: any) => {
        let selectedState = event.currentTarget.value;
        setSelectedState(selectedState);
        if (countryValue === "US" && LookupType !== "PROVISIONAL") {
            const disclosureText: any = await stateDisclosureAPI(selectedState, disclaimerType, productService, partnerId, RetailerCode, null, null);
            setCreditDisclosureText(disclosureText);
        }
    };

    const IsWhiteLabeled: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    useEffect(() => {
        window.scrollTo(0, 0);
        countryChangeDetected();
    }, []);

    useEffect(() => {
        const getDisclosureText = async () => {
            let state =
                registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0 && registrationState.addressInfo.state
                    ? registrationState.addressInfo.state
                    : userData && userData.state;
            setSelectedState(state);
            if (countryValue === "US" && LookupType !== "PROVISIONAL") {
                let result: any = await stateDisclosureAPI(selectedState, disclaimerType, productService, partnerId, RetailerCode, null, null);
                return result;
            }
        };
        getDisclosureText().then((value: any) => setCreditDisclosureText(value));
    }, [showDisclosure, showDisclosure === false, NonCreditServiceType]);

    const onSubmit = (data: any) => {
        if ((registrationState.addressInfo && registrationState.addressInfo.country !== "US") || registrationState.addressInfo.country !== "CA") {
            data.state = data.state.toUpperCase().substring(0, 2);
        }

        data.country = countryValue;
        data.formOne = false;
        setRegistrationState({ ...registrationState, addressInfo: data });

        if (ShowTermsAndConditionScreenFirst && isTypeSSOProvisional) {
            manageState(updateState(FirstTermsStates, displayData.billingRequired, 3));
        }
        else if (((PSSValue && PSSValue.includes('PSS') && !IsWhiteLabeled) || (checkLookUpType || isTypeWalkup)) && !displayData.billingRequired) {
            manageState(updateState(states, displayData.billingRequired, 3));
        }
        else {
            manageState(updateState(states, displayData.billingRequired, 2));
        }
    };

    return (
        <>
            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box box-has-shadow offset-padding">
                        <div className="box-header">
                            <div className="row box-title-container">
                                {showLogoOnRegistrationScreens && (
                                    <div className="col-xs-12 col-sm-0 hide-sm-up text-align-center">
                                        <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                    </div>
                                )}
                                <div className={showLogoOnRegistrationScreens ? "col-xs-12 col-sm-6" : ""}>
                                    <div className="box-title-icon" aria-hidden="true">
                                        <RenderIcons iconName={"user"} />
                                    </div>
                                    <div className="box-title-text">
                                        <h2 className="box-title">{tLang("registration.personalInfo2Widget.title")}</h2>
                                    </div>
                                </div>
                                {showLogoOnRegistrationScreens && (
                                    <div className="col-xs-0 col-sm-6 row flex-end">
                                        <LogoContainer internalPage={false} className="hide-mobile" showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="box-content">
                            <form onSubmit={handleSubmit(onSubmit)} id="register-personal-info-1">
                                <div className="row between-sm">
                                    <div className="col-xs-12 col-sm-7 col-no-gutter">
                                        <p>{tLang("registration.personalInfo2Widget.message")}</p>
                                        <div className="margin-bottom-l"></div>

                                        <div className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label">
                                                        {" "}
                                                        <label htmlFor="label-address-line-1">
                                                            {isBusinessUser
                                                                ? tLang("registration.personalInfo2Widget.label.businessStreet")
                                                                : tLang("registration.personalInfo2Widget.label.street")}
                                                            <span className="required" title="Mandatory">
                                                                {" "}
                                                                *
                                                            </span>
                                                        </label>{" "}
                                                    </legend>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className={`form-row row ${errors["address1"] && "status-error"}`}>
                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                            <label htmlFor="label-address-line1">Address Line 1 </label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="address1"
                                                                className="inputbox"
                                                                id="label-address-line-1"
                                                                defaultValue={getDefaultAddress()}
                                                                placeholder={tLang("registration.personalInfo2Widget.placeholder.addressLine1")}
                                                                ref={register({
                                                                    required: true,
                                                                    pattern: PATTERNS.STREETADDRESS.pattern,
                                                                })}
                                                                aria-required="true"
                                                            />
                                                            {errors["address1"] && errors["address1"].type === "required" && (
                                                                <span role="alert" className="form-error">
                                                                    {tLang("registration.personalInfo2Widget.validationMessage.address1.required")}
                                                                </span>
                                                            )}
                                                            {errors["address1"] && errors["address1"].type === "pattern" && (
                                                                <span role="alert" className="form-error">
                                                                    {tLang("registration.personalInfo2Widget.validationMessage.address1.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className={`form-row row ${errors["address2"] && "status-error"}`}>
                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                            <label htmlFor="label-address-line-2">Address Line 2 </label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="address2"
                                                                className="inputbox"
                                                                id="label-address-line-2"
                                                                defaultValue={getDefaultAddress2()}
                                                                placeholder={tLang("registration.personalInfo2Widget.placeholder.addressLine2")}
                                                                ref={register({
                                                                    pattern: PATTERNS.STREETADDRESS.pattern,
                                                                })}
                                                            />
                                                            {errors["address2"] && errors["address2"].type === "pattern" && (
                                                                <span role="alert" className="form-error">
                                                                    {tLang("registration.personalInfo2Widget.validationMessage.address2.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {selectedState === 'PR' && <fieldset className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label">
                                                        {" "}
                                                        <label htmlFor="label-address-urbanization">Urbanization</label>
                                                    </legend>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="row">
                                                        <div className="col-xs-12 col-no-gutter">
                                                            <div className="form-row row">
                                                                <div className="form-input col-xs-12 col-no-gutter">
                                                                    <input
                                                                        type="text"
                                                                        name="urbanization"
                                                                        className="inputbox"
                                                                        id="label-address-urbanization"
                                                                        defaultValue={
                                                                            registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0
                                                                                ? registrationState.addressInfo.urbanization
                                                                                : ""
                                                                        }
                                                                        ref={register({ required: false })}
                                                                        placeholder="Urbanization(Optional)"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>}
                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label">
                                                        {" "}
                                                        <label htmlFor="label-address-city">
                                                            {tLang("registration.personalInfo2Widget.label.city")}
                                                            <span className="required" title="Mandatory">
                                                                {" "}
                                                                *
                                                            </span>
                                                        </label>
                                                    </legend>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="row">
                                                        <div className="col-xs-12 col-no-gutter">
                                                            <div className="form-row row">
                                                                <div className="form-input col-xs-12 col-no-gutter">
                                                                    <input
                                                                        type="text"
                                                                        name="city"
                                                                        className="inputbox"
                                                                        id="label-address-city"
                                                                        defaultValue={getDefaultCity()}
                                                                        ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                                        placeholder={tLang("registration.personalInfo2Widget.placeholder.city")}
                                                                        aria-required="true"
                                                                    />
                                                                    {errors["city"] && errors["city"].type === "required" && (
                                                                        <span role="alert" className="form-error">
                                                                            {tLang("registration.personalInfo2Widget.validationMessage.city.required")}
                                                                        </span>
                                                                    )}
                                                                    {errors["city"] && errors["city"].type === "pattern" && (
                                                                        <span role="alert" className="form-error">
                                                                            {tLang("registration.personalInfo2Widget.validationMessage.city.pattern")}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                {countryValue === "US" || !supportInternational ? (
                                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                            <label htmlFor="label-address-state">
                                                                {tLang("registration.personalInfo2Widget.label.state")}
                                                                <span className="required" title="Mandatory">
                                                                    {" "}
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                            <select
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                defaultValue={getDefaultState()}
                                                                name="state"
                                                                ref={register({ required: true, validate: (value) => value !== "---" })}
                                                                onChange={onStateChange}
                                                                aria-required="true"
                                                            >
                                                                {stateList.map((val: any) => (
                                                                    <option key={val.name} value={val.value}>
                                                                        {val.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors["state"] && errors["state"].type === "validate" && (
                                                                <span role="alert" className="form-error">
                                                                    {tLang("registration.personalInfo2Widget.validationMessage.state.required")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : countryValue === "CA" ? (
                                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                            <label htmlFor="label-address-state">
                                                                {tLang("registration.personalInfo2Widget.label.province")}
                                                                <span className="required" title="Mandatory">
                                                                    {" "}
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                            <select
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                defaultValue={getDefaultState()}
                                                                name="state"
                                                                ref={register({ required: true, validate: (value) => value !== "---" })}
                                                                aria-required="true"
                                                            >
                                                                {CAProvinces.map((val: any) => (
                                                                    <option key={val.name} value={val.value}>
                                                                        {val.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors["state"] && errors["state"].type === "validate" && (
                                                                <span role="alert" className="form-error">
                                                                    {tLang("registration.personalInfo2Widget.validationMessage.province.required")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className={`form-row inline row ${errors["state"] && "status-error"}`}>
                                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                            <label htmlFor="label-address-state">
                                                                Region
                                                                <span className="required" title="Mandatory">
                                                                    {" "}
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                name="state"
                                                                defaultValue={getDefaultState()}
                                                                ref={register({ required: true, pattern: PATTERNS.REGION.pattern })}
                                                                className="inputbox"
                                                                id="label-address-state"
                                                                aria-required="true"
                                                            />
                                                            {errors["state"] && errors["state"].type === "required" && (
                                                                <span role="alert" className="form-error">
                                                                    {tLang("registration.personalInfo2Widget.validationMessage.region.required")}
                                                                </span>
                                                            )}
                                                            {errors["state"] && errors["state"].type === "pattern" && (
                                                                <span role="alert" className="form-error">
                                                                    {tLang("registration.personalInfo2Widget.validationMessage.region.pattern")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>

                                        <div className={`form-row inline row ${errors["zipcode"] && "status-error"}`}>
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-address-zipcode">
                                                    {zipCode.Label === "Zip Code"
                                                        ? tLang("registration.personalInfo2Widget.label.zipcode")
                                                        : tLang("registration.personalInfo2Widget.label.postalCode")}
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                <input
                                                    type="text"
                                                    className="inputbox"
                                                    id="label-address-zipcode"
                                                    placeholder={
                                                        zipCode.Label === "Zip Code"
                                                            ? tLang("registration.personalInfo2Widget.placeholder.zipCode")
                                                            : tLang("registration.personalInfo2Widget.label.postalCode")
                                                    }
                                                    defaultValue={getDefaultZip()}
                                                    name="zipcode"
                                                    ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern, maxLength: zipCode.MaxLength })}
                                                    aria-required="true"
                                                />
                                                {errors["zipcode"] && errors["zipcode"].type === "required" && (
                                                    <span role="alert" className="form-error">
                                                        {zipCode.Label === "Zip Code"
                                                            ? tLang("registration.personalInfo2Widget.validationMessage.zipCode.required")
                                                            : tLang("registration.personalInfo2Widget.validationMessage.postalCode.required")}
                                                    </span>
                                                )}
                                                {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                                                    <span role="alert" className="form-error">
                                                        {zipCode.Pattern === "ZIPCODE"
                                                            ? tLang("registration.personalInfo2Widget.validationMessage.zipCode.pattern")
                                                            : tLang("registration.personalInfo2Widget.validationMessage.postalCode.pattern")}
                                                    </span>
                                                )}
                                                {errors["zipcode"] && errors["zipcode"].type === "maxLength" && (
                                                    <span role="alert" className="form-error">
                                                        {zipCode.Label === "Zip Code"
                                                            ? tLang("registration.personalInfo2Widget.validationMessage.zipCode.pattern")
                                                            : tLang("registration.personalInfo2Widget.validationMessage.postalCode.pattern")}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {displayData.routingNumberRequired && (
                                            <>
                                                <div className={`form-row inline row ${errors["routingNumber"] && "status-error"}`}>
                                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                        <label htmlFor="label-routing-number">
                                                            Routing Number
                                                            {checkLookUpType ? <span className="required" title="Mandatory"> {" "}*</span> : null }

                                                        </label>
                                                    </div>
                                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                        <input
                                                            type="text"
                                                            placeholder={`${LookupType === "WALKUP" ? "Routing Number (Optional)" : "Routing Number "}`}
                                                            defaultValue={
                                                                registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0
                                                                    ? registrationState.addressInfo.routingNumber
                                                                    : ""
                                                            }
                                                            className="inputbox"
                                                            id="label-routing-number"
                                                            name="routingNumber"
                                                            ref={register({ required: checkLookUpType, pattern: /^(\d{9})|$^[0-9]*$/ })}
                                                            maxLength={9}
                                                            aria-required={checkLookUpType }
                                                        />
                                                        {errors["routingNumber"] && errors["routingNumber"].type === "required" && (
                                                            <span role="alert" className="form-error">Routing number is required.</span>
                                                        )}
                                                        {errors["routingNumber"] && errors["routingNumber"].type === "pattern" && (
                                                            <span role="alert" className="form-error">
                                                                Invalid format. Routing Number must be 9 digits and only include numbers.
                                                            </span>
                                                        )}
                                                        <p>
                                                            Please verify the financial institution that referred you to Deluxe Provent by entering your financial
                                                            institution's routing number. This number is nine characters long and is located in the lower left
                                                            corner of your checks (or find online at{" "}
                                                            <a href="http://www.routingnumbers.org/" className="default_link">
                                                                www.routingnumbers.org
                                                            </a>
                                                            )
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className={`form-row inline row ${errors["confirmRoutingNumber"] && "status-error"}`}>
                                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                        <label htmlFor="label-confirm-routing-number">
                                                            Confirm Routing Number
                                                            {checkLookUpType ? <span className="required" title="Mandatory"> {" "}*</span> : null}
                                                        </label>
                                                    </div>
                                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                        <input
                                                            type="text"
                                                            placeholder="Confirm Routing Number"
                                                            className="inputbox"
                                                            defaultValue={
                                                                registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0
                                                                    ? registrationState.addressInfo.confirmRoutingNumber
                                                                    : ""
                                                            }
                                                            id="label-confirm-routing-number"
                                                            name="confirmRoutingNumber"
                                                            ref={register({
                                                                required: checkLookUpType,
                                                                pattern: /^(\d{9})|$^[0-9]*$/,
                                                                validate: (value) => value === watch("routingNumber") || "Confirm routing number do not match.",
                                                            })}
                                                            maxLength={9}
                                                            aria-required={checkLookUpType}
                                                        />
                                                        {errors["confirmRoutingNumber"] && errors["confirmRoutingNumber"].type === "validate" && (
                                                            <span role="alert" className="form-error">Confirm routing number do not match.</span>
                                                        )}
                                                        {errors["confirmRoutingNumber"] && errors["confirmRoutingNumber"].type === "required" && (
                                                            <span role="alert" className="form-error">Routing number is required.</span>
                                                        )}
                                                        {errors["confirmRoutingNumber"] && errors["confirmRoutingNumber"].type === "pattern" && (
                                                            <span role="alert" className="form-error">
                                                                Invalid format. Routing Number must be 9 digits and only include numbers.
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {!isTypeSSOProvisional && (
                                        <Cart
                                            registrationLookup={registrationLookup}
                                            displayData={displayData}
                                            registrationState={registrationState}
                                            setRegistrationState={setRegistrationState}
                                            selectedCountry={registrationState.addressInfo.country}
                                            creditDisclosureText={creditDisclosureText}
                                            getproductServiceType={getproductServiceType}
                                            NonCreditServiceType={NonCreditServiceType}
                                        />
                                    )}
                                </div>

                                <div className="margin-vertical-l"></div>

                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li className="margin-left-s">
                                                <button onClick={() => setForm(true)} type="button" className="btn-default btn-default btn-min-width">
                                                    <span className="btn-text">{isPreviousOrBack}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button
                                                    type="submit"
                                                    className="btn-default btn-primary btn-min-width"
                                                    onClick={() => window.addToDataLayer({ event: "Next Button AddressInformation Click" })}
                                                >
                                                    <span className="btn-text">{isNextOrContinue}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddressInformation;
